
import themes from "@/mixins/themes"
import ContactPersonAvatar from "@/components/base/image/ContactPersonAvatar"

export default {
    name: "JobPublicContactPerson",
    components: {
        ContactPersonAvatar,
        Button: () => import("@/components/base/Button"),
        BusinessResponseTime: () =>
            import("@/components/business/BusinessResponseTime"),
    },
    mixins: [themes],
    emits: ["chat", "start-request"],
    props: {
        /** business object */
        business: {
            type: Object,
            required: true,
        },
        /** Hide chat button */
        hideChat: {
            type: Boolean,
            default: false,
        },
        /** Hide "ausprobieren" button */
        hideInterest: {
            type: Boolean,
            default: false,
        },
        /** Theme's background type */
        themeBackground: {
            type: String,
            default: "backgroundPrimary",
            validator: (val) =>
                ["backgroundPrimary", "backgroundSecondary"].includes(val),
        },
        /** If job is an traineeship */
        isTraineeship: {
            type: Boolean,
            default: false,
        },
        hideHeadline: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        contactPerson() {
            return this.business?.public_contact_person
        },
        displayName() {
            if (this.contactPerson?.firstname || this.contactPerson?.lastname) {
                return `${this.contactPerson.firstname ?? ""} ${
                    this.contactPerson.lastname ?? ""
                }`
            }
            return this.business.name
        },
        displayGender() {
            return this.contactPerson?.gender
        },
        responseTimeColor() {
            return this.oaTheme.backgroundSecondary.color.isTextDark
                ? "#ffffff"
                : "#000000"
        },
    },
    methods: {
        onQuestion() {
            this.$oabalytics.trackEvent("job-chat")
            this.$survey?.startTimer()
            this.$emit("chat")
        },
        onStartRequest() {
            this.$oabalytics.trackEvent("job-interest")
            this.$survey?.startTimer()
            this.$emit("start-request")
        },
    },
}
